import { addModal } from 'weblite-web-modal-viewer'
import { JoinHallDialog } from './join-hall-dialog'

const COMPONENT_ID = 'joinHallDialog'

export const showJoinHallModal = (
  props: Omit<Parameters<typeof JoinHallDialog>[0], 'isOpen'>,
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: JoinHallDialog,
  },
}
